// extracted by mini-css-extract-plugin
export default {"container":"ScrollToTopButton_container__iDsVf","toTopArrowBox":"ScrollToTopButton_toTopArrowBox__AF9u2"};